<div class="main-content">
  <nav class="navbar navbar-top navbar-horizontal navbar-expand-md navbar-dark">
    <div class="container px-4">
      <a class="navbar-brand" routerLinkActive="active" [routerLink]="['/'+mainPath]">
        <img src="assets/img/brand/white.png" />
      </a>
      <button class="navbar-toggler" type="button" (click)="isCollapsed=!isCollapsed"
        aria-controls="sidenav-collapse-main">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" [class.show]="!isCollapsed" id="sidenav-collapse-main">
        <!-- Collapse header -->
        <div class="navbar-collapse-header d-md-none">
          <div class="row">
            <div class="col-6 collapse-brand">
              <a routerLinkActive="active" [routerLink]="['/'+mainPath]">
                <img src="assets/img/brand/normal.png">
              </a>
            </div>
            <div class="col-6 collapse-close">
              <button type="button" class="navbar-toggler" (click)="isCollapsed=!isCollapsed">
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>
        <!-- Navbar items -->
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link nav-link-icon" routerLinkActive="active" [routerLink]="['/'+mainPath]">
              <i class="sdx sdx-bag"></i>
              <span class="nav-link-inner--text">{{ 'label.store' | transloco }}</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link nav-link-icon" routerLinkActive="active" [routerLink]="['/'+registerPath]">
              <i class="sdx sdx-user-circle"></i>
              <span class="nav-link-inner--text">{{ 'register.title' | transloco }}</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link nav-link-icon" routerLinkActive="active" [routerLink]="['/'+loginPath]">
              <i class="sdx sdx-key"></i>
              <span class="nav-link-inner--text">{{ 'login.title' | transloco }}</span>
            </a>
          </li>
          <li class="nav-item ml-auto">
            <a class="nav-link nav-link-icon" href="" (click)="openLanguageModal()">
              <i class="sdx sdx-world"></i>
              <span class="nav-link-inner--text">{{ 'language.title' | transloco }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
  <router-outlet></router-outlet>
</div>
<footer class="py-5">
  <div class="container">
    <div class="row align-items-center justify-content-xl-between">
      <div class="col-xl-4">
        <div class="copyright text-center text-xl-left text-muted">
          &copy; {{ anio | date: "yyyy" }} <a href="{{webUrl}}" class="font-weight-bold ml-1" target="_blank">{{ ciaName
            }}</a>
        </div>
      </div>
      @if (enableSocialLink) {
      <div class="col-xl-4 text-center">
        @if (TWITTER_LINK !== '') {
        <a href="{{TWITTER_LINK}}" target="_blank">
          <i class="sdx sdx-twitter"></i>
        </a>

        &nbsp;
        }
        @if (YOUTUBE_LINK !== '') {
        <a href="{{YOUTUBE_LINK}}" target="_blank">
          <i class="sdx sdx-youtube"></i>
        </a>
        &nbsp;
        }
        @if (FACEBOOK_LINK !== '') {
        <a href="{{FACEBOOK_LINK}}" target="_blank">
          <i class="sdx sdx-facebook"></i>
        </a>
        &nbsp;
        }
        @if (INSTAGRAM_LINK !== '') {
        <a href="{{INSTAGRAM_LINK}}" target="_blank">
          <i class="sdx sdx-instagram"></i>
        </a>
        &nbsp;
        }
        @if (LINKEDIN_LINK !== '') {
        <a href="{{LINKEDIN_LINK}}" target="_blank">
          <i class="sdx sdx-linkedin"></i>
        </a>
        }
      </div>
      }
      <div class="col-xl-4">
        <ul class="nav nav-footer justify-content-center justify-content-xl-end">
          <li class="nav-item">
            <a [routerLink]="['/'+aboutPath]" class="nav-link">{{ 'label.about-us' | transloco }}</a>
          </li>
          <li class="nav-item">
            <a [routerLink]="['/'+privacyPolicyPath]" class="nav-link" target="_blank">{{ 'label.privacy-policy' |
              transloco }}</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer>